import { reportNames } from "./stringConstants";

export const SET_LANGUAGE = "SET_LANGUAGE";
export type SET_LANGUAGE = typeof SET_LANGUAGE;

export const SET_COUNTRY = "SET_COUNTRY";
export type SET_COUNTRY = typeof SET_COUNTRY;

export const AUTHENTICATE = "AUTHENTICATE";
export type AUTHENTICATE = typeof AUTHENTICATE;

export const INCREMENT_ENTHUSIASM = "INCREMENT_ENTHUSIASM";
export type INCREMENT_ENTHUSIASM = typeof INCREMENT_ENTHUSIASM;

export const ROLE_CLIENT_ADMIN = "client-admin";
export const ROLE_SUPER_ADMIN = "super-admin";

export const DATE_FORMAT = "MM-DD-YYYY";
export const DATE_TIME_FORMAT = "MM-DD-YYYY HH:mm";

export const BASE_URL_SCHOOLSIMS = "https://schoolsims.com";
export const WEBINARS_URL = "/webinars/";

export const BLOGS_URL = "/blog/";

export const BEST_PRACTISES_URL = "/best-practices/";

export const EVENTS_URL = "/events/";

export const RESEARCH_URL = "/simulation-based-research/";
export const CLIENT_TESTIMONIALS_URL = "/client-testimonials/";

export const ALL_REPORT_TYPES = [
  {
    value: "countSimsUsed-Admin",
    label: "Count of Sims Used",
    role: [ROLE_CLIENT_ADMIN, ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "simsUser-Admin",
    label: "Sims User",
    role: [ROLE_CLIENT_ADMIN, ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
      multipleAccountSelection: true,
    },
  },
  {
    value: "mostActiveClients-Admin",
    label: "Client Links Generated",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "uniqueSimsByclient-Admin",
    label: "Unique Sims by Clients",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "unpaidStudents-Admin",
    label: "Unpaid Students",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "neverLoggedOnUser-Admin",
    label: "Never Logged on User",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "simsFeedback-Admin",
    label: reportNames.simsFeedBackReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "not show",
      selectionTypeExcelOnly: true,
      accountActiveFilter: true,
    },
  },
  {
    value: "usersByAccount-Admin",
    label: "Users by Account",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "totalSimsPlayedByClients-Admin",
    label: "Sims Played Count and Average Feedback",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "paidTracnsationsByAccount-Admin",
    label: "Paid Transactions by Account",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "access-codes-used-by-account",
    label: "Access Codes Used by Account",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
      multipleAccountSelection: true,
    },
  },
  {
    value: "90DaysSimPlayedComparison",
    label: "90 Days Sim Played Comparison by Account",
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: true,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "90DaysSimPlayedComparisonBySim",
    label: "90 Days Sim Played Comparison by Sim",
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "AccountFeedbackLast90Days",
    label: "Account Feedback Last 90 Days",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: true,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "FreeTextResponse",
    label: "FreeText Response from SimBuilder Sims",
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "SimsPlayedbyHour",
    label: "Sims Played by Hour",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "ClientFacilitatedSimsLast90Days",
    label: "Client Facilitated Sims Last 90 Days",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "studentAccountExpiration",
    label: "Student Account Expiration Report",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      simSelection: false,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "simDecisionAnalytics",
    label: "Simulation Decision Analytics",
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: true,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      type: "json",
      sort: true,
      bothSelectionType: true,
      accountActiveFilter: true,
    },
  },
  {
    value: "allSimBuilderSimsFeedback",
    label: "All SimBuilder Simulations Feedback Report",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      simSelection: true,
      multipleAccountSelection: true,
      optionalAccAndSims: "not show",
      accountActiveFilter: true,
    },
  },
  {
    value: "rawDataVersionOfSimSummary",
    label: "Raw Data Version Of Sim Summary Report",
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: true,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      type: "json",
      selectionTypeExcelOnly: true,
      emailSelection: true,
      accountActiveFilter: true,
    },
  },
  {
    value: "cohortProgressReport",
    label: "Cohort Progress Report",
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      simSelection: false,
      cohortSelection: true,
      optionalAccAndSims: "not show",
      selectionTypeExcelOnly: true,
      emailSelection: false,
      accountActiveFilter: false,
      participantFilter: true,
    },
  },
  {
    value: "wellnessReport",
    label: "Wellness Report",
    role: [ROLE_CLIENT_ADMIN, ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      cohortSelection: true,
      optionalAccAndSims: "not show",
      selectionTypeExcelOnly: true,
      emailSelection: false,
      accountActiveFilter: false,
      participantFilter: true,
    },
  },
  {
    value: "jobConfidenceReport",
    label: "Job Confidence Report",
    role: [ROLE_CLIENT_ADMIN, ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: false,
      cohortSelection: true,
      optionalAccAndSims: "not show",
      selectionTypeExcelOnly: true,
      emailSelection: false,
      accountActiveFilter: false,
      participantFilter: true,
      restrictToNonHigherEd: true,
    },
  },
  {
    value: "mceeResult",
    label: "MCEE Ethics Report",
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: true,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      selectionTypeExcelOnly: false,
      emailSelection: false,
      accountActiveFilter: true,
    },
  },
  {
    value: "recordedResponseTrackReport",
    label: "Recorded Response Track Report",
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      simSelection: true,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
    },
  },
  {
    value: "cohortParticipationInsightsReport",
    label: reportNames.cohortParticipationInsightsReport,
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      optionalAccAndSims: "show",
      emailSelection: false,
      accountActiveFilter: false,
      selectionTypeExcelOnly: false,
      modifiedFilterSelection: true,
    },
  },
  {
    value: "clientSummaryReport",
    label: reportNames.clientSummaryReport,
    role: [ROLE_SUPER_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      monthSelection: true,
    },
  },
  {
    value: "onDemandProfessionalStandardSummaryReport",
    label: reportNames.onDemandProfessionalStandardSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      type: "json",
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      simSelection: true,
    },
  },
  {
    value: "monthlySnapshotProfessionalStandardSummaryReport",
    label: reportNames.monthlySnapshotProfessionalStandardSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      monthSelection: true,
    },
  },
  {
    value: "onDemandCaepSimulationSummaryReport",
    label: reportNames.onDemandCaepSimulationSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      type: "json",
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      simSelection: true,
    },
  },
  {
    value: "monthlySnapshotCaepSimulationSummaryReport",
    label: reportNames.monthlySnapshotCaepSimulationSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      quadrimesterSelection: true,
    },
  },
  {
    value: "onDemandAaqepSimulationSummaryReport",
    label: reportNames.onDemandAaqepSimulationSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      type: "json",
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      simSelection: true,
    },
  },
  {
    value: "quadrimestralSnapshotAaqepSimulationSummaryReport",
    label: reportNames.quadrimestralSnapshotAaqepSimulationSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      quadrimesterSelection: true,
    },
  },
  {
    value: "onDemandNelpPselStandardSummaryReport",
    label: reportNames.onDemandNelpPselStandardSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: true,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      type: "json",
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      simSelection: true,
    },
  },
  {
    value: "quadrimestralSnapshotNelpPselStandardSummaryReport",
    label: reportNames.quadrimestralSnapshotNelpPselStandardSummaryReport,
    role: [ROLE_SUPER_ADMIN, ROLE_CLIENT_ADMIN],
    hasDate: {
      dateRangeFilter: false,
      createdDateFilter: false,
      multipleAccountSelection: true,
      optionalAccAndSims: "show",
      emailSelection: false,
      accountActiveFilter: true,
      selectionTypeExcelOnly: true,
      quadrimesterSelection: true,
    },
  },
];

var ip = window.location.hostname;
var protocol = window.location.protocol === "https:" ? "https" : "http";

export const API_ENDPOINT = `${protocol}://${ip}/api/`;
export const BASE_ENDPOINT = `${protocol}://${ip}/`;
export const PUBLIC_ENDPOINT = `${protocol}://${ip}`;
export const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL || "cx@schoolsims.com";

export const LOCAL_SIM_URL = import.meta.env.VITE_LOCAL_SIM_URL || "";
export const SIM_BUILDER_URL = import.meta.env.VITE_SIM_BUILDER_URL || "";

export const STRIPE_PUBLIC_TOKEN = import.meta.env.VITE_STRIPE_PUBLIC_KEY || "";

export const Configs = {
  aws: {
    s3: {
      bucketName: import.meta.env.VITE_AWS_S3_BUCKET_NAME,
      region: import.meta.env.VITE_AWS_S3_BUCKET_REGION,
      s3Url: import.meta.env.VITE_AWS_S3_BUCKET_URL,
    },
  },
};

/**
 * The HELP_PAGE_LINK is used to redirect the help icons to the specified link
 */
export const HELP_PAGE_LINK = "https://schoolsims.com/support/";
